import { QueryKey } from '@/config/query-client';
import { useQuery } from '@tanstack/react-query';
import { appliedProjectsFiltersState } from '../project.state';
import { fetchProjectKPIs } from '@/api/v4/projects.api';
import { prepareProjectApiFilters } from '../filters/project-filters-helpers';
import { getTimeInMs } from '@/helpers/get-time-in-ms';
import { useAtomValue } from 'jotai';

export const useProjectKpi = () => {
  const appliedFilters = useAtomValue(appliedProjectsFiltersState);

  const getProjectsKPIs = async () =>
    fetchProjectKPIs({
      ...prepareProjectApiFilters(appliedFilters),
    });

  return useQuery({
    queryKey: [QueryKey.ProjectsKpi, appliedFilters],
    queryFn: getProjectsKPIs,
    staleTime: getTimeInMs(5, 'minute'),
    gcTime: getTimeInMs(15, 'minute'),
  });
};
